import { EntityCard } from './EntityCard';

interface OrganizationCardProps {
  id: number;
  slug: string;
  name: string;
  description?: string | null;
  logoUrl?: string | null;
  storesCount: number;
  isActive?: boolean;
  onClick?: (slug: string) => void;
}

/**
 * 조직 카드 컴포넌트
 * 녹색 테마의 EntityCard 래퍼
 */
export function OrganizationCard(props: OrganizationCardProps) {
  return <EntityCard {...props} theme="organization" />;
}
